import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Typography } from '@material-ui/core';
import {
  LandingPageV2State,
  updateNotifications,
} from '../../containers/LandingPageV2/LandingPageV2.duck';
import { useShopConfig } from '../../hooks/shopConfig';
import { UpdateGeneralSavedSearchEmailSubscriptionParams } from '../../types/models/savedSearch';

import { BuilderSection, SectionFooterActionV2, SubscribeForm, TypographyWrapper } from '..';
import { RequestStatus } from '../../types/requestStatus';
import { BuilderSections } from '../../util/builder';

const SubscribeFooterAction: FC = () => {
  const {
    copy: { subscribeTitle, subscribeSubtitle },
    marketingSettingsConfig: { hideSizesFromSubscribe = false } = {},
    builderConfig,
  } = useShopConfig();

  const subscribeFooterActionBuilderSectionId =
    builderConfig?.sections?.[BuilderSections.SubscribeFormFooterContent];

  const dispatch = useDispatch();
  const { updateNotificationsStatus } = useSelector<any>(
    (state) => state.LandingPageV2
  ) as LandingPageV2State;

  const descriptionCopy =
    subscribeSubtitle ||
    'Get updates for new releases, discounts, and personalized “just for you” collections from Treet.';
  const headerCopy = subscribeTitle || 'Nothing catching your eye?';

  const onSubscribe = (params: UpdateGeneralSavedSearchEmailSubscriptionParams) =>
    dispatch(updateNotifications(params));

  if (subscribeFooterActionBuilderSectionId) {
    return (
      <BuilderSection
        sectionType={BuilderSections.SubscribeFormFooterContent}
        sectionId={subscribeFooterActionBuilderSectionId}
      />
    );
  }

  const headerEl = (
    <TypographyWrapper
      variant="h1"
      typographyOverrides={{ style: { color: 'white', textAlign: 'center' } }}
    >
      {headerCopy}
    </TypographyWrapper>
  );

  let footerActionEl;
  if (updateNotificationsStatus === RequestStatus.Success) {
    footerActionEl = (
      <Typography variant="h2" style={{ color: 'white', textAlign: 'center', fontWeight: 'bold' }}>
        Thank you, your email is subscribed!
      </Typography>
    );
  } else {
    footerActionEl = (
      <Box pt={2}>
        <SubscribeForm onSubscribe={onSubscribe} areSizesEnabled={!hideSizesFromSubscribe} />
      </Box>
    );
  }

  return (
    <SectionFooterActionV2
      headerEl={headerEl}
      description={descriptionCopy}
      actionEl={footerActionEl}
    />
  );
};

export default SubscribeFooterAction;
